const color = {
    blue: "#0082fc",
    lightBlue: "#a1d1ff",
    darkBlue: "#003f7a",
    red: "#ff0000",
    lightRed: "#fca4a4",
    darkRed: "#ee0508",
    greenDebugging: "#00ff11"
}

const circleRadius = 3
const circleRadiusHalo = 5
const lineWidth = 3
const lineColorActive = color.lightBlue
const fillOutlineColor = color.darkBlue
const perimeterLineColor = color.blue

export const DRAWING_STYLE = [
    {
        id: "gl-draw-line",
        type: "line",
        filter: [
            "all",
            ["==", "$type", "LineString"],
            ["!=", "mode", "static"],
        ],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": perimeterLineColor,
            "line-width": lineWidth,
        },
    },
    {
        id: "gl-draw-polygon-fill",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        paint: {
            "fill-color": perimeterLineColor,
            "fill-outline-color": fillOutlineColor,
            "fill-opacity": 0.2,
        },
    },
    {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": lineColorActive,
            "line-width": lineWidth,
        },
    },
    {
        id: "gl-draw-polygon-and-line-vertex-halo-active",
        type: "circle",
        filter: [
            "all",
            ["==", "meta", "vertex"],
            ["==", "$type", "Point"],
            ["!=", "mode", "static"],
        ],
        paint: {
            "circle-radius": circleRadiusHalo,
            "circle-color": "#FFF",
        },
    },
    {
        id: "gl-draw-polygon-and-line-vertex-active",
        type: "circle",
        filter: [
            "all",
            ["==", "meta", "vertex"],
            ["==", "$type", "Point"],
            ["!=", "mode", "static"],
        ],
        paint: {
            "circle-radius": circleRadius,
            "circle-color": fillOutlineColor,
        },
    },
    {
        id: "gl-draw-line-static",
        type: "line",
        filter: [
            "all",
            ["==", "$type", "LineString"],
            ["==", "mode", "static"],
        ],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": perimeterLineColor,
            "line-width": lineWidth,
        },
    },
    {
        id: "gl-draw-polygon-fill-static",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        paint: {
            "fill-color": color.darkRed,
            "fill-opacity": 0.8,
        },
    },
    {
        id: "gl-draw-polygon-stroke-static",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round",
        },
        paint: {
            "line-color": color.darkRed,
            "line-width": lineWidth,
        },
    },
]
